import React from "react";
import {
  PencilSquareIcon,
  TrashIcon,
  XCircleIcon,
} from "@heroicons/react/24/solid";

const EllipsisDetailsCard = (props) => {
  const {
    userPermission,
    editPermission,
    deletePermission,
    salesChartData,
    nsaChartData,
    splcChartData,
  } = props;

  const Edit = userPermission?.includes(editPermission);
  const Deactivate =
    userPermission?.includes(deletePermission) &&
    (salesChartData?.isActive ||
      nsaChartData?.isActive ||
      splcChartData?.isActive);

  const ellipsis =
    salesChartData?.id === 1283 ||
    nsaChartData?.id === 1283 ||
    splcChartData?.id === 1283
      ? "card-container cards_chief"
      : "card-container cards";

  return (
    <div className={ellipsis}>
      <button className="absolute -top-2 -right-2">
        <XCircleIcon className="close text-octonary cursor-pointer" />
      </button>

      {Edit && (
        <button
          className={`edit flex items-center place-content-center hover:text-primary ${
            !Deactivate ? "mr-9 mb-1" : ""
          }`}
        >
          <PencilSquareIcon className="h-4 w-4 mr-1" />
          Edit
        </button>
      )}

      {Deactivate && (
        <button className="deactivate flex items-center place-content-center hover:text-primary">
          <TrashIcon className="h-4 w-4 mr-1" />
          Deactivate
        </button>
      )}
    </div>
  );
};

export default EllipsisDetailsCard;
